/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from "react";
import TableContainer from "../../Components/Table";
import { useNavigate } from "react-router-dom";
import CustomTab from "../../Components/SwitchTab";
import PageContainer from "../PageContainer";
import Alert from "../../Components/AlertPopup";
import { AUDIT_MODES, ERROR_MESSAGE } from "../../constants";
import { getAuditLevelLabel, getDateFormat } from "../../utils";
import { getOverview } from "../../api/common";
import styles from "./style.module.scss";
import AuditCompleted from "../AuditviewCompleted";
import SubmitButton from "../../Components/Button";
import OrganizationList from "../../Components/OrgModal/OrganizationList";
import Info from "../../icons/infoIcon.svg?react";
import AuditInformationModal from "../../Components/InfoModal/AuditInformationModal";
import { setSelectedMembers, setSelectedThemes } from "../../reducers/Audit";
import { setMappedBanksvalues } from "../../reducers/bankSlice";
import { useDispatch } from "react-redux";

const AuditOverview = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const navigate = useNavigate();
  const [activeTabKey, setActiveTabKey] = useState<string>("AuditClosure");
  const [showToast, setShowToast] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [element, setElement] = useState([]);

  const navigateTo = (route: string) => {
    navigate(route);
  };

  const handleTabChange = useCallback((key: string | null) => {
    if (key) {
      setActiveTabKey(key);
    }
  }, []);

  const columnData = [
    { label: "No", key: "no" },
    { label: "Audit ID", key: "auditCode" },
    {
      label: "Organization",
      key: "orgDetails",
      tdClassname: "text-start wrapTheme",
    },
    {
      label: "Application",
      key: "applicationList",
      tdClassname: "text-start wrapTheme",
    },
    { label: "Theme", key: "theme", tdClassname: "text-start wrapTheme" },
    { label: "Level", key: "auditLevel", tdClassname: "text-center" },
    {
      label: "Duration",
      key: "duration",
      isMoreField: true,
      tdClassname: "text-center",
    },
    { label: "Response Time", key: "responseTime", isMoreField: true },
    {
      label: "Reminder Alert",
      key: "escalationFrequency",
      tdClassname: "text-center",
      isMoreField: true,
    },
    { label: "Status", key: "stage" },
    { label: "Info", key: "info", disableSortBy: true },
  ];

  const MoreFeildsValue = [
    { label: "Duration", value: "duration" },
    {
      label: "Response Time",
      value: "responseTime",
      tdClassname: "text-start",
    },
    { label: "Reminder Alert", value: "escalationFrequency" },
  ];

  const getUniqueAppNames = (orgs: any[]) => {
    const names: string[] = [];
    orgs.forEach((o) =>
      o.applications?.forEach((a: any) => {
        if (!names.includes(a.applicationName)) names.push(a.applicationName);
      })
    );
    return names.join(", ");
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const finalSet: any[] = [];
      const response = await getOverview();

      if (response && response.length) {
        response.forEach((element: any, i: number) => {
          const kickoffDate =
            element.kickOffFromDate && element.kickOffToDate
              ? `${getDateFormat(element.kickOffFromDate, "DD/MM/YYYY")} - ${getDateFormat(
                element.kickOffFromDate,
                "hh:mm A"
              )} to ${getDateFormat(element.kickOffToDate, "hh:mm A")}`
              : "N/A";

          finalSet.push({
            ...element,
            no: i + 1,
            kickoffDate,
            auditMode: AUDIT_MODES[element.auditMode] || "Unknown",
            auditLevel: `${element.auditLevel} (${getAuditLevelLabel(element.auditLevel)})`,
            createdDate: getDateFormat(element.createdOn, "DD/MM/YYYY"),
            theme: element.themes
              .map((data: any) => data?.themeName)
              .join(", "),
            applicationList: getUniqueAppNames(element.organizations),
            duration: `${element.startDate?.split("-")?.reverse()?.join("/")} - ${element.endDate?.split("-")?.reverse()?.join("/")}`,
            escalationFrequency: element.escalationFrequency ? `${element.escalationFrequency} Days` : "-",
            responseTime: `${element.responseTime} Days`,
            orgDetails: (
              <OrganizationList
                title="Organization Under Audit ID:"
                auditCode={element.auditCode}
                organizations={element.organizations}
              />
            ),
            info: (
              <span>
                <Info
                  className={styles.iconStyleActions}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowInfo(true);
                    setElement(element);
                  }}
                />
              </span>
            ),
            stage: (
              <span
                className={`${styles.stageBadge} ${styles[element.stage?.toLowerCase().replace(" ", "-")] || styles.unknown}`}
              >
                {element.stage || "-"}
              </span>
            ),
          });
        });
      }

      setRowData(finalSet);
    } catch (err) {
      console.error(err);
      setShowErrorToast(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeTabKey === "AuditClosure") fetchData();
  }, [activeTabKey]);

  // Pagination slicing
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentClosure = rowData.slice(indexOfFirstItem, indexOfLastItem);

  // Tab configuration
  const tabData = [
    { text: "Ongoing Audits", key: "AuditClosure" },
    { text: "Completed Audits", key: "AuditCompleted" },
  ];
  return (
    <PageContainer>
      <div className={styles.title}>Audit Lists</div>
      <div className="d-flex justify-content-between align-items-center">
        <CustomTab
          data={tabData}
          activeKey={activeTabKey}
          onTabChange={handleTabChange}
          alignWithFilter={true}
          customTab="mb-3 customTab"
          top={0}
        />
        <div>
          <SubmitButton
            type="primary"
            onClick={() => {
              navigateTo("/audit-overview/add");
              dispatch(setSelectedThemes([]));
              dispatch(setSelectedMembers([]));
              dispatch(setMappedBanksvalues([]));
            }}
            className={styles.createAuditBtn}
          >
            Create Audit Plan
          </SubmitButton>
        </div>
      </div>

      {activeTabKey === "AuditClosure" ? (
        <TableContainer
          columnData={columnData}
          rowData={currentClosure}
          totalResult={rowData.length}
          enableMoreFeilds={true}
          MoreFeildsValue={MoreFeildsValue}
          title={"List of Ongoing Audits"}
          enableActionButton={false}
          enableFilter={true}
          itemsPerPage={pageSize}
          currentPage={currentPage}
          setCurrentPage={(pageNumber) => setCurrentPage(pageNumber)}
          onPageNoChange={(pageNumber) => setCurrentPage(pageNumber)}
          onPageLimitChange={(newLimit) => {
            setPageSize(newLimit);
            setCurrentPage(1);
          }}
          showLoading={loading}
          noRecordMessage={"There are no ongoing Audits."}
        />
      ) : (
        <AuditCompleted />
      )}
      <Alert
        show={showToast}
        onClose={() => {
          setShowToast(false);
        }}
        message={"The audit plan has been Deleted successfully!!"}
      />
      <Alert
        type="error"
        show={showErrorToast}
        onClose={() => setShowErrorToast(false)}
        message={ERROR_MESSAGE.API_ERROR_MESSAGE}
      />
      <AuditInformationModal
        element={element}
        show={showInfo}
        onHide={() => setShowInfo(false)}
      />
    </PageContainer>
  );
};

export default AuditOverview;
